export enum LoadingStatuses {
  IDLE = 1,
  PENDING = 2,
  FULFILLED,
  FAILED,
}
